<div layout-margin>
    <mat-tab-group *ngIf="dataAvailable === true ">
        <!-- <mat-tab label="Parâmetros">
            <app-settings-params></app-settings-params>
        </mat-tab> -->
        <!-- <mat-tab label="Setores">
            <app-settings-setores></app-settings-setores>
        </mat-tab> -->
        <!-- <mat-tab label="Anúncios">
            <app-settings-ads></app-settings-ads>
        </mat-tab> -->
        <!-- *ngIf="painelAtivo === 'true' " -->
        <mat-tab  label="Painéis">
            <app-settings-painel></app-settings-painel>
        </mat-tab>
        <!-- *ngIf="painelAtivo === 'true'"  -->
        <mat-tab label="Totems">
            <app-settings-totem></app-settings-totem>
        </mat-tab>
    </mat-tab-group>
    <a href="https://google.com" target="_blank" class="question">
        <span>Ajuda</span>
        <mat-icon>help_outline</mat-icon>
    </a>
</div>